/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:49:32
 * @Last Modified by: Nora
 * @Last Modified time: 2020-09-03 11:20:07
 */
import template from '@/app/editor/sidebar/templates/gfElement/heading.html';

export const headingSettings = [
  {
    name: 'titleTag',
    id: 'titleTag',
    caption: 'Title Tag',
    type: 'select',
    options: {
      h1: 'H1',
      h2: 'H2',
      h3: 'H3',
      h4: 'H4',
      h5: 'H5',
      h6: 'H6',
    },
    default_value: 'h3',
    target: '.text-edit',
    ref: 'html|heading',
  },
  {
    caption: 'Typography',
    type: 'group',
    mode: 'responsive-mode',
    items: [
      {
        name: 'fontWeight',
        id: 'fontWeight',
        caption: 'Font Weight',
        type: 'select',
        options: {
          '100': 'Thin 100',
          '200': 'Semi Thin 200',
          '300': 'Light 300',
          '400': 'Regular 400',
          '500': 'Medium 500',
          '600': 'Semi Bold 600',
          bold: 'Bold 700',
          '800': 'Super Bold 800',
          '900': 'Boldest 900',
          lighter: 'Lighter',
          bolder: 'Bolder',
        },
        default_value: '400',
        mode: 'responsive-mode',
        ref: 'css|font-weight',
        target: '.text-edit+heading',
      },
      {
        name: 'font-size',
        id: 'font-size',
        class: 'gf_to-range',
        caption: 'Font Size',
        type: 'input',
        min: '6',
        max: '100',
        step: '1',
        unit: 'px',
        default_value: '20px',
        mode: 'responsive-mode',
        target: '.text-edit+heading',
        ref: 'css|font-size',
      },
      {
        name: 'line-height',
        id: 'line-height',
        class: 'gf_to-range',
        caption: 'Line Height',
        type: 'input',
        min: '0.5',
        max: '3',
        step: '0.1',
        unit: 'em',
        default_value: '1.2em',
        mode: 'responsive-mode',
        target: '.text-edit+heading',
        ref: 'css|line-height',
      },
      {
        name: 'letter-spacing',
        id: 'letter-spacing',
        class: 'gf_to-range',
        caption: 'Letter Spacing',
        type: 'input',
        min: '-1',
        max: '4',
        step: '0.1',
        unit: 'px',
        default_value: '1',
        mode: 'responsive-mode',
        target: '.text-edit+heading',
        ref: 'css|letter-spacing',
      },
      {
        name: 'text-color',
        id: 'text-color',
        class: 'gryff-color',
        caption: 'Text Color',
        type: 'text',
        default_value: '',
        mode: 'responsive-mode',
        target: '.text-edit+heading',
        ref: 'css|color',
      },
      {
        name: 'font',
        id: 'font',
        class: 'gf_font',
        caption: 'Font',
        type: 'text',
        default_value: '',
        mode: 'responsive-mode',
        target: '.text-edit+heading',
        ref: 'css|font-family',
      },
      {
        name: 'textTransform',
        caption: 'Text Transform',
        class: 'textTransform',
        type: 'select',
        options: {
          none: 'None',
          uppercase: 'Uppercase',
          lowercase: 'Lowercase',
          capitalize: 'Capitalize',
        },
        target: '.text-edit+heading',
        ref: 'css|text-transform',
      },
    ],
  },
  {
    caption: 'Text Shadow',
    type: 'group',
    mode: 'responsive-mode',
    items: [
      {
        name: 'box-shadow-enable',
        id: 'box-shadow-enable',
        caption: 'Enable',
        type: 'text',
        class: 'gf_to-switch',
        default_value: '0',
        mode: 'responsive-mode',
      },
      {
        name: 'box-shadow-color',
        id: 'box-shadow-color',
        class: 'gryff-color',
        caption: 'Shadow Color',
        type: 'input',
        default_value: '#333333',
        target: '.text-edit+heading',
        ref: 'style|text-shadow',
        mode: 'responsive-mode',
        requires: 'box-shadow-enable|1',
      },
    ],
    advanced: [
      {
        name: 'gf-to-shadowXY',
        class: 'gf-to-shadowXY',
        caption: 'Shadow Type',
        type: 'text',
        default_value: '3.5355339059327378,3.5355339059327373',
        mode: 'responsive-mode',
        target: '.text-edit+heading',
        ref: 'css|text-shadow',
      },
      {
        name: 'box-shadow-blur',
        id: 'box-shadow-blur',
        class: 'gf_to-range',
        caption: 'Shadow Blur',
        type: 'input',
        min: '0',
        max: '50',
        step: '1',
        unit: 'px',
        default_value: '5',
        mode: 'responsive-mode',
        target: '.text-edit+heading',
        requires: 'box-shadow-enable|1',
      },
    ],
  },
  {
    name: 'alignment',
    id: 'alignment',
    class: 'gf_to-align',
    type: 'select',
    caption: 'Alignment',
    options: {
      left: 'Left',
      center: 'Center',
      right: 'Right',
      justify: 'Justify',
    },
    default_value: 'center',
    mode: 'responsive-mode',
    target: '.text-edit',
    ref: 'class|align',
  },
  {
    name: 'extra_class',
    caption: 'Extra class name',
    type: 'text',
    desc: 'If you wish to style particular content element differently, then use this field to add a class name and then refer to it in your css file.',
    target: '.text-edit',
    ref: 'class|classname',
  },
];

export default {
  name: 'Heading',
  slug: 'heading',
  class: 'text-edit',
  id: 'md-text-block',
  html: template(),
  settings: headingSettings,
};
